import React from "react";
import GridContainer from "./GridContainer";
import {Input , Textarea , Label} from "../../../libs/components/FormControls";

function ClientInfoPanel({clientInfo,onClientInfoEdit}) {
  return (
    <div>
      <GridContainer>
      <Label>Business Name:</Label>
      <Input
        type="text"
        value={clientInfo.businessname}
        onChange={e => onClientInfoEdit("businessname", e.target.value)}
      ></Input>
      <Label>First Name:</Label>
      <Input
        type="text"
        value={clientInfo.firstname}
        onChange={e => onClientInfoEdit("firstname", e.target.value)}
      ></Input>
      <Label>Last Name:</Label>
      <Input
        type="text"
        value={clientInfo.lastname}
        onChange={e => onClientInfoEdit("lastname", e.target.value)}
      ></Input>
      <Label>Phone Number:</Label>
      <Input
        type="text"
        value={clientInfo.phoneNumber}
        onChange={e => {
          onClientInfoEdit("phoneNumber", e.target.value)
          // props.setActionLink('CALL',e.target.value)
        }}
      ></Input>
      <Label>Whatsapp Number:</Label>
      <Input
        type="text"
        value={clientInfo.whatsapp}
        onChange={e => onClientInfoEdit("whatsapp", e.target.value)}
      ></Input>
      <Label>Location:</Label>
      <Input
        type="text"
        value={clientInfo.location}
        onChange={e => onClientInfoEdit("location", e.target.value)}
      ></Input>
      <Label>Facebook:</Label>
      <Input
        type="text"
        value={clientInfo.facebook}
        onChange={e => {
          onClientInfoEdit("facebook", e.target.value)
          // props.setActionLink('FACEBOOK',e.target.value)
        }}
      ></Input>
      <Label>Instagram:</Label>
      <Input
        type="text"
        value={clientInfo.instagram}
        onChange={e => onClientInfoEdit("instagram", e.target.value)}
      ></Input>
      <Label>About:</Label>
      <Textarea
        value={clientInfo.about}
        onChange={e => onClientInfoEdit("about", e.target.value)}
      />
      <Label>Opening Hours:</Label>
      <Textarea
        value={clientInfo.openingHours}
        onChange={e => onClientInfoEdit("openingHours", e.target.value)}
      />
      <Label>Services:</Label>
      <Textarea
        value={clientInfo.servicesDescription}
        onChange={e => onClientInfoEdit("servicesDescription", e.target.value)}
      />
    </GridContainer>
    </div>
  );
}

export default ClientInfoPanel;


